import { render, staticRenderFns } from "./ProductItemFeature.vue?vue&type=template&id=26364d58&"
import script from "./ProductItemFeature.vue?vue&type=script&lang=js&"
export * from "./ProductItemFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports